import { productAction } from "./action"

const initialState = {
  initProduct: null,
  shopCart: [],
}

export function productReducer(state = initialState, action) {
  switch (action.type) {
    case productAction.FETCH_PRODUCT_SUCCESS: {
      return Object.assign({}, state, { initProduct: action.payload })
    }

    case productAction.UPDATE_PRODUCT_SHOPCART: {
      return Object.assign({}, state, { shopCart: action.payload })
    }

    case productAction.SET_PRODUCT_STATE: {
      return Object.assign({}, state, action.payload)
    }

    default:
      return state
  }
}
